<template>
    <div>
        <div v-if="isUpdating">
            <span>
                Mise à jour en cours...
                <i class="fas fa-spinner-third fa-spin"></i>
            </span>
        </div>
        <div v-else class="d-flex align-items-center justify-content-center">
            <div v-if="isCadorLinked">
                <i v-if="!isCurrent" class="fas fa-lock mr-2 text-muted"></i>
                <span> {{ exercice.text }}</span>
                <b-link @click="triggerUpdate">
                    <i
                        class="fas fa-arrow-alt-to-bottom fa-lg ml-2 text-primary"
                    ></i>
                </b-link>
            </div>
            <div v-else>
                <span>-</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ClientsCadorTableItem',

    props: {
        isCurrent: {
            type: Boolean,
            required: true,
        },
        clientId: {
            type: Number,
            required: true,
        },
        exercice: {
            type: Object,
            required: true,
        },
        isCadorLinked: {
            type: Boolean,
            required: true,
        },
    },

    data() {
        return {
            isUpdating: false,
            updateProgressInfos: {},
        }
    },

    async created() {
        if (this.isCadorLinked) {
            if (this.exercice.is_updating) {
                this.isUpdating = this.exercice.is_updating
                await this.getUpdateProgress()
                this.getProgressOnInterval()
            } else {
                this.getProgressOnInterval()
            }
        }
    },

    methods: {
        async fetchCadorData() {
            try {
                await this.$axios.get(
                    `/cador/client/${this.clientId}/${this.exercice.year}/update`
                )
            } catch (e) {
                this.showErrorToast(e)
            }
        },

        async getUpdateProgress() {
            console.log('progress')
            try {
                const response = await this.$axios.get(
                    `/cador/client/${this.clientId}/${this.exercice.year}/progress`
                )
                this.updateProgressInfos = response.data
            } catch (e) {
                this.showErrorToast(e)
            }
        },

        getProgressOnInterval() {
            const interval = setInterval(() => {
                this.getUpdateProgress()
                if (this.updateProgressInfos.is_updating === !this.isUpdating) {
                    this.isUpdating = false
                    // clearInterval(interval)
                    this.$emit('client-updated')
                }
            }, 10000)
        },

        async triggerUpdate() {
            this.isUpdating = true
            await this.fetchCadorData()

            await this.getUpdateProgress()
            this.getProgressOnInterval()
        },
    },
}
</script>

<style scoped></style>
